/**
 * Redux Store Configuration
 * 
 * Configuración central del store de Redux Toolkit
 * Listo para migrar las vistas gradualmente
 */
import { configureStore } from '@reduxjs/toolkit';
import type { TypedUseSelectorHook } from 'react-redux';
import bookingsReducer from './slices/bookingsSlice';
import contractsReducer from './slices/contractsSlice';
import tariffsReducer from './slices/tariffsSlice';
import supplierInvoicesReducer from './slices/supplierInvoicesSlice';
import supplierInvoiceLinesReducer from './slices/supplierInvoiceLinesSlice';
import internalInvoicesReducer from './slices/internalInvoicesSlice';
import internalInvoiceLinesReducer from './slices/internalInvoiceLinesSlice';
import entitiesReducer from './slices/entitiesSlice';
import contactsReducer from './slices/contactsSlice';
import carriersReducer from './slices/carriersSlice';
import portsReducer from './slices/portsSlice';
import currenciesReducer from './slices/currenciesSlice';
import countriesReducer from './slices/countriesSlice';
import equipmentReducer from './slices/equipmentSlice';
import nomenclatorsReducer from './slices/nomenclatorsSlice';
import usersReducer from './slices/usersSlice';
import invoiceConceptsReducer from './slices/invoiceConceptsSlice';
import importsReducer from './slices/importsSlice';
import uiReducer from './slices/uiSlice';
export const store = configureStore({
  reducer: {
    // Operaciones
    bookings: bookingsReducer,
    contracts: contractsReducer,
    tariffs: tariffsReducer,
    // Finanzas
    supplierInvoices: supplierInvoicesReducer,
    supplierInvoiceLines: supplierInvoiceLinesReducer,
    internalInvoices: internalInvoicesReducer,
    internalInvoiceLines: internalInvoiceLinesReducer,
    // Maestros
    entities: entitiesReducer,
    contacts: contactsReducer,
    carriers: carriersReducer,
    ports: portsReducer,
    currencies: currenciesReducer,
    countries: countriesReducer,
    equipment: equipmentReducer,
    nomenclators: nomenclatorsReducer,
    users: usersReducer,
    invoiceConcepts: invoiceConceptsReducer,
    // Otros
    imports: importsReducer,
    ui: uiReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorar acciones que contengan funciones o fechas
        ignoredActions: ['bookings/setFilters', 'contracts/setFilters'],
        ignoredActionPaths: ['meta.arg', 'payload.timestamp'],
        ignoredPaths: ['items.dates'],
      },
    }),
});
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
// Re-export TypedUseSelectorHook para conveniencia
export type { TypedUseSelectorHook };
